import React from "react";
import "../styles/about.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faInstagram,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import BlurImage from "./BlurImage";

const About = () => {
  return (
    <div className="page">
      <section className="intro">
        <div className="container">
          <div className="row1">
            <h2>About-me</h2>
            <div className="img-wrapper no-select">
              <BlurImage
                src={require(`../assets/avatar.webp`)}
                alt="Vishal Jaiswal"
                base64="data:image/webp;base64,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"
              />
            </div>
            <h2>
              Vishal Jaiswal - <span>Front-end</span>{" "}
              Developer
            </h2>
            <div className="social-links">
              <a
                className="social"
                href="mailto:jaiswalvishal86@gmail.com"
              >
                <FontAwesomeIcon
                  icon={faEnvelope}
                  size="2x"
                />
              </a>
              <a
                rel="noopener noreferrer"
                className="social"
                href="https://github.com/jaiswalvishal86"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faGithub}
                  size="2x"
                />
              </a>
              <a
                rel="noopener noreferrer"
                className="social"
                href="https://www.linkedin.com/in/vishal-jaiswal-38835a19b/"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  size="2x"
                />
              </a>
              <a
                rel="noopener noreferrer"
                className="social"
                href="https://twitter.com/vishj_rocks"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faTwitter}
                  size="2x"
                />
              </a>
              <a
                rel="noopener noreferrer"
                className="social"
                href="https://www.instagram.com/guycalledvishal/"
                target="_blank"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  size="2x"
                />
              </a>
            </div>
            <p>
              "Results-oriented Front-end Developer
              dedicated to creating and optimizing
              interactive, user-friendly, and feature-rich
              websites. Leverage analytical skills and
              strong attention to detail in order to deliver
              original and efficient web solutions, provide
              technical knowledge and expertise, build new
              websites from start to finish, and
              successfully manage a team of other software
              professionals."
            </p>
            <p>
              I have mostly worked with JavaScript, React
              and NodeJS but also a little bit with C and
              Python. I enjoy being challenged and engaging
              with projects that require me to work outside
              my comfort and knowledge set, as continuing to
              learn new languages and development techniques
              are important to me and the success of your
              organization.
            </p>
            <div className="sec-para">
              <h3>
                Why Work With Me{" "}
                <span role="img" aria-label="emoji">
                  🤔
                </span>
              </h3>
              <p>
                There’s nothing I enjoy more than designing
                and developing good websites for nice
                people. It really is that simple.
              </p>
              <p>
                I’ve spent many years trying to perfect what
                I do and while I’ll never be perfect, I do
                my best to come close.
              </p>
              <p>
                If you’ve got a project you’d like to work
                on with me just get in touch and we can get
                to work!
              </p>
              <h3>
                Future Goals{" "}
                <span role="img" aria-label="emoji">
                  🏃‍♂️
                </span>
              </h3>
              <p>
                Right now, I’m excited about the still very
                complicated WebAssembly, and working towards
                becoming a React senior. In the following
                years, I also plan to explore the
                “server-side” more and become a
                better-rounded full-stack dev.
              </p>
            </div>
            <div className="seperator"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
